import { render, staticRenderFns } from "./x-form.vue?vue&type=template&id=5ae37392&"
import script from "./x-form.vue?vue&type=script&lang=js&"
export * from "./x-form.vue?vue&type=script&lang=js&"
import style0 from "./x-form.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/welearn-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5ae37392', component.options)
    } else {
      api.reload('5ae37392', component.options)
    }
    module.hot.accept("./x-form.vue?vue&type=template&id=5ae37392&", function () {
      api.rerender('5ae37392', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/controls/x-form.vue"
export default component.exports